/* eslint-disable max-lines */
/* eslint-disable max-len */

import { useState } from "react";
import { IEsimPackage } from "../../interfaces/esim/EsimPackages.types";

interface CreatePackageFormProps {
  newPackage: Partial<IEsimPackage>;
  setNewPackage: (
    value: Partial<IEsimPackage> |
    ((prev: Partial<IEsimPackage>) => Partial<IEsimPackage>)
  ) => void;
  onCreate: () => void;
  onCancel: () => void;
}

export const CreatePackageForm: React.FC<CreatePackageFormProps> = ({
  newPackage,
  setNewPackage,
  onCreate,
  onCancel
}) => {
  // Local state to handle string inputs for decimal fields
  const [costInput, setCostInput] = useState<string>(newPackage.cost?.toString() ?? "");
  const [oldCostInput, setOldCostInput] = useState<string>(newPackage.oldCost?.toString() ?? "");

  const handleCostChange = (value: string) => {
    setCostInput(value);
    const numericValue = value === "" ? undefined : parseFloat(value);
    if (value === "" || !isNaN(numericValue as number)) {
      setNewPackage((prev) => ({
        ...prev,
        cost: numericValue
      }));
    }
  };

  const handleOldCostChange = (value: string) => {
    setOldCostInput(value);
    const numericValue = value === "" ? undefined : parseFloat(value);
    if (value === "" || !isNaN(numericValue as number)) {
      setNewPackage((prev) => ({
        ...prev,
        oldCost: numericValue
      }));
    }
  };

  return (
    <div className="p-6">
      <h3 className="text-lg font-semibold mb-4">Create New Package</h3>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Data (GB)</span>
          <input
            type="text"
            value={newPackage.totalGB ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              setNewPackage((prev) => ({
                ...prev,
                totalGB: value === "" ? undefined : Number(value)
              }));
            }}
            placeholder="0"
            className="w-20 p-1 border rounded text-right
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Validity (days)</span>
          <input
            type="text"
            value={newPackage.validityDays ?? ""}
            onChange={(e) => {
              const value = e.target.value;
              setNewPackage((prev) => ({
                ...prev,
                validityDays: value === "" ? undefined : Number(value)
              }));
            }}
            placeholder="0"
            className="w-20 p-1 border rounded text-right
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Price</span>
          <input
            type="text"
            inputMode="decimal"
            value={costInput}
            onChange={(e) => handleCostChange(e.target.value)}
            placeholder="0.00"
            className="w-20 p-1 border rounded text-right
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Old Price</span>
          <input
            type="text"
            inputMode="decimal"
            value={oldCostInput}
            onChange={(e) => handleOldCostChange(e.target.value)}
            placeholder="0.00"
            className="w-20 p-1 border rounded text-right
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Recommended</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={newPackage.isRecommended ?? false}
              onChange={(e) => {
                setNewPackage((prev) => ({
                  ...prev,
                  isRecommended: e.target.checked
                }));
              }}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-600">Unlimited</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={newPackage.isUnlimited ?? false}
              onChange={(e) => {
                setNewPackage((prev) => ({
                  ...prev,
                  isUnlimited: e.target.checked
                }));
              }}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onCancel();
            }}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onCreate();
            }}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};
